// Shared in-memory clipboard for Strg+C/V and the context menu (survives side switches, not page reloads).
export const clipboard = { items: null };
